export default "__VITE_ASSET__CnmFqDJ5__"